import { BlockType } from 'pn-backend';
import { always } from 'ramda';
import { FC } from 'react';

import { BlockProps } from '~types';

// Блок используется для превью постов в сетках
export const PreviewBlock: FC<BlockProps<BlockType.Preview>> = always(null);
